interface Props {
  id?: string;
  rotulo?: string;
  titulo?: string;
  /** Pares [item, quantidade]. */
  conteudo: [string, string][];
}

/** Declaracao de conteudo: o formulario aduaneiro dizendo o que vai na caixa. */
export function Declaracao({
  id,
  rotulo = "Declaração de conteúdo",
  titulo = "O que vem na caixa",
  conteudo,
}: Props) {
  return (
    <section id={id} className="lp-secao">
      <p className="lp-rotulo lp-rotulo-ponto">{rotulo}</p>
      <h2 className="lp-secao-titulo">{titulo}</h2>

      <div className="lp-declaracao">
        <div className="lp-declaracao-topo">
          <span className="lp-rotulo">Item</span>
          <span className="lp-rotulo">Quantidade</span>
        </div>
        {conteudo.map(([item, qtd]) => (
          <div key={item} className="lp-linha-item">
            <span>{item}</span>
            <span className="lp-linha-qtd">{qtd}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
